import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class TeamType extends Enum {
  key!: string;
  value!: string;

  static JUNIOR_ESTATE_PROFESSIONAL: TeamType = {
    key: 'junior_estate_professional',
    get value(): string {
      return Lang.t('team.junior-estate-professional');
    }
  };

  static ACCOUNTANT: TeamType = {
    key: 'accountant',
    get value(): string {
      return Lang.t('team.accountant');
    }
  };

  static FINANCIAL_ADVISOR_PORTAL: TeamType = {
    key: 'financial_advisor_portal',
    get value(): string {
      return Lang.t('team.financial-advisor-portal');
    }
  };
}
